export const mapFetchErrorToFormError = fetchError => {
  // force cast inexact -> exact: https://stackoverflow.com/questions/42288594/is-it-possible-to-cast-an-object-to-an-exact-type-in-flow
  // $FlowFixMe[unclear-type]
  const errors = fetchError.errors;
  const mailboxesErrors = (errors.payload?.['domain:mailboxes']?.values || []).map(value => value.login);
  const nsAddresses = errors.payload?.['domain:nameservers']?.addresses || [];
  const nsAndRecords = {
    nameservers: nsAddresses.length ? nsAddresses.join('\n') : undefined,
    records: errors.payload?.['dns:records']?.text
  };
  const mailboxes = mailboxesErrors[0] || mailboxesErrors[1] ? {
    mailbox1: mailboxesErrors[0] || undefined,
    mailbox2: mailboxesErrors[1] || undefined
  } : undefined;
  return {
    name: errors.name,
    nsAndRecords,
    mailboxes
  };
};